import TitleHeader from "@standard/components/TitleHeader";
import DNReturnForm from "./DNReturnForm";
import DNReturnDataTable from "./DNReturnDataTable";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const programType = "Transaction";
const programName = "DN Return";
const url = "transaction/dnreturn";

export default function DNReturn() {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <DNReturnDataTable url={url} />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <DNReturnForm url={url} />
        </Route>
      </Switch>
    </>
  );
}
